import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import classnames from 'classnames'

import Header from './components/Header'
import AgendaView from './components/AgendaView'
import WeekView from './components/WeekView'
import MonthView from './components/MonthView'

import { SIDEPANEL_WIDTH } from '../../utils'

export default function index() {
  const { view } = useSelector(state=>state.dateFilter)
  const { showSidePanel } = useSelector(state=>state.config)
  return (
    <Container
      className={classnames("bg-white h-100 border-right border-bottom", { "border-left": !showSidePanel })}
      style={{width: showSidePanel ? `calc(100% - ${ SIDEPANEL_WIDTH })` : '100%'}}>
      <Header/>
      <CalendarView view={view}/>
    </Container>
  )
}

const Container = styled.div`
  width: calc( 100% - ${SIDEPANEL_WIDTH} );
  @media(max-width: 990px){
    width: 100% !important;
    border-left: 1px solid rgb(207, 216, 220);
  }
`

function CalendarView({view}){
  switch(view){
    case "week":
      return (<WeekView/>)
    case "month":
      return <MonthView/>
      case "agenda":
    default:
      return (<AgendaView/>)
  }
}